export default __webpack_public_path__ + "static/media/volontary.179a3239.jpg";